import { type InferOutput, looseObject } from "valibot";
import type { DefaultDtoType, Field } from "./Field";
import { initField } from "./Field";
import InlineMessage from "../components/inlineMessage/InlineMessage";
import type { TranslationKey } from "../state/i18n";
import { useTranslation } from "../state/i18n";
import { directUserToSupport } from "../utils/supportUtil";
import type { WidgetUid } from "../types";
import { keyFromSelector } from "i18next";

const Schema = looseObject({});

export type UnknownFieldProperties = InferOutput<typeof Schema>;
const UnknownField: Field<UnknownFieldProperties, DefaultDtoType> = {
  type: "unknown",
  category: "unknown",
  widget: "" as WidgetUid,
  schema: Schema,
  hasData: false,
  defaultProperties: () => ({}),
  icon: "exclamation",
  titleKey: keyFromSelector(($) => $.UNKNOWN_FIELD_LABEL),
  descriptionKey: "" as TranslationKey, // Should not be used, rendered or translated
  init: () => {
    throw new Error("'Unknown' fields cannot be created");
  },
  EditItem: () => {
    const { t } = useTranslation();

    return (
      <InlineMessage
        variant="warning"
        label={t(($) => $.UNKNOWN_FIELD_UNSUPPORTED_MESSAGE)}
        layout="column"
        action={{
          label: t(($) => $.UNKNOWN_FIELD_UNSUPPORTED_MESSAGE_ACTIONS_CONTACT_SUPPORT_LABEL),
          onClick: directUserToSupport,
        }}
      />
    );
  },
  PreviewContent: () => {
    const { t } = useTranslation();
    return <InlineMessage variant="warning" label={t(($) => $.UNKNOWN_FIELD_UNSUPPORTED_MESSAGE)} />;
  },
  MenuItem: () => {
    throw new Error("'Unknown' fields cannot be shown in fields menu");
  },
  FavouriteMenuItem: () => {
    throw new Error("'Unknown' fields cannot be made into favourites");
  },
  propertyKeys: {},
};

export default initField(UnknownField);
